// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "jquery"

Rails.start()
ActiveStorage.start()

$(document).ready(function() {
  $("[data-form-prepend]").click(function(e) {
    var decoded = $("<textarea>").html($(this).attr("data-form-prepend")).text();
    var obj = $(decoded);
    obj.find("input, select, textarea").each(function() {
      $(this).attr("name", function() {
        return $(this)
          .attr("name")
          .replace("new_record", new Date().getTime());
      });
    });
    $(this).parents('.container').find('.nodes').append(obj);
    return false;
  });

  $(document).on('click', '.delete-row', function(e) {
    $(this).parents('.row').first().remove();
    return false;
  });
});
